module.exports = __webpack_public_path__ + "img/vignettes-asso_0007_seuil.f3c821c9.jpg";